'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var text = {
  fontFamily: 'body',
  lineHeight: 'base'
};
exports["default"] = text;